import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'

export default class Icon extends Component {
    render() {
        const {icon, customClass} = this.props;
        return (
            <FontAwesome
              className={customClass}
              name={icon}
           
            />
          )
    }
}
